export default __webpack_public_path__ + "static/media/pin.d81a6407.svg";